import React, { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { MenuItem } from "react-contextmenu";

import {
  setContextMenu,
  setModal
} from "../../../../actions/index";

import ModalCTA from '../../modal/ModalCTA';
import ModalButton from '../../modal/ModalButton';

import IconPrivate from '../svg/IconPrivate';
import IconPublic from '../svg/IconPublic';
import IconHost from '../svg/IconHost';
// import IconMute from '../svg/IconMute';
import IconPause from '../svg/IconPause';
import IconRemove from '../svg/IconRemove';

const useActionUser = (userID) => {
  const dispatch = useDispatch();
  const socket = useSelector( state => state.socketPM);
  const host = useSelector( state => !!(state.inRoomPM && state.user && state.inRoomPM.owner === state.user.id));
  const inRoomPM = useSelector( state => state.inRoomPM );
  const isPrivate = inRoomPM.private;
  const roomName = inRoomPM.name;
  const players = useSelector( state => state.playersInRoomPM );
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEnable, setEnable] = useState(false);

  useEffect(() => {
    const user = players.find( x => x.id === userID );
    setSelectedUser(user);
    setEnable(!!user && host)
  }, [players, userID, host])

  const toggleType = () => { socket.emit("modify room", { name: roomName, private: !isPrivate }); }
  const toggleSpectator = () => { socket.emit(`update user spectator`, { userID }) }
  const toggleActive = () => { socket.emit(`update user active`, { userID }) }
  // const toggleMute = () => { socket.emit(`update user mute`, { userID }) }
  const kick = () => {
    const validClick = () => { socket.emit(`kick user`, { userID })  }
    dispatch(setModal({
      content: (
        <ModalCTA
          title={`Are you sure you want to kick ‘${selectedUser.name}’?`}
          styleContainer={{marginTop: `-70%`, marginLeft: `-10%`}}
          styleBody={{ gap: 36 }}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Kick`} onClick={validClick} />
          <ModalButton label={`Close`} className={`cancel`} />
        </ModalCTA>
      )
    }));
  }
  const toggleHost = (userID, name) => () => {
    const validClick = () => {
      socket.emit(`switch host`, { userID })
    }
    dispatch(setModal({
      content: (
        <ModalCTA
          title={`Change host to ‘${name}’?`}
          styleContainer={{marginTop: `-70%`, marginLeft: `-10%`}}
          styleBody={{ gap: 36 }}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Change host`} onClick={validClick} />
          <ModalButton label={`Close`} className={`cancel`} />
        </ModalCTA>
      )
    }));
  }

  const prepareContextMenu = useCallback(() => {
    if (selectedUser) {
      let menus = [];
      if (selectedUser.admin) {
        dispatch(setContextMenu([
          // <MenuItem key={`tracker-state`} onClick={toggleTracker} data={{ action: 'tracker state' }}>{isTracker ? `Disable Ghost` : `Enable Ghost`}</MenuItem>,
          <MenuItem key={`type-room-state`} onClick={toggleType} data={{ action: 'type state' }}>
            <div className={'flexRow block-contextmenu-item all-hover'}>
              { isPrivate ? <IconPublic className={'icon-public'} /> : <IconPrivate /> }
              {`Make party ${isPrivate ? `public` : `private`}`}
            </div>
          </MenuItem>
        ], {className: 'dynamic-menu-pm-host-menu'}));
      } else {
        if (selectedUser.subscribed && !selectedUser.active) {
          menus.push(
            <MenuItem key={`active-state`} onClick={toggleActive} data={{ action: 'active state' }}>
              <div className={'flexRow block-contextmenu-item all-hover'}>
                <IconPublic />
                {`Set as ${selectedUser.active ? `Fan` : `DJ` }`}
              </div>
            </MenuItem>
          );
        }
        if (selectedUser.active) {
          menus.push(
            <MenuItem key={`host-state`} onClick={toggleHost(selectedUser.id, selectedUser.name)} data={{ action: 'host state' }}>
              <div className={'flexRow block-contextmenu-item all-hover-fill'}>
                <IconHost />
                Set as Host
              </div>
            </MenuItem>);
          menus.push(
            <MenuItem key={`spectator-state`} onClick={toggleSpectator} data={{ action: 'spectactor state' }}>
              <div className={`flexRow block-contextmenu-item all-hover-fill ${selectedUser.spectator && 'selected'}`}>
                <IconPause />
                {selectedUser.spectator ? `DJ control paused` : `Pause DJ control`}
              </div>
            </MenuItem>
          );
        }
        // menus.push(
        //   <MenuItem key={`mute`} onClick={toggleMute} data={{ action: 'Mute' }}>
        //     <div className={'flexRow block-contextmenu-item all-hover-fill'}>
        //       <IconMute />
        //       {selectedUser.mute ? `chat muted` : `Mute chat`}
        //     </div>
        //   </MenuItem>
        // );
        menus.push(
          <MenuItem key={`kick`} onClick={kick} data={{ action: 'Kick' }}>
            <div className={'flexRow block-contextmenu-item'}>
              <IconRemove />
              {`Remove user`}
            </div>
          </MenuItem>
        );

        dispatch(setContextMenu(menus, {className: 'dynamic-menu-pm-host-menu'}));
      }
      return menus.length;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser, isPrivate])

  const storeX = {
    isEnable,
    prepareContextMenu
  };

  return storeX;
};

export default useActionUser;
